"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matches = void 0;
const assertString_1 = require("./util/assertString");
function matches(str, patternOrString, modifiers) {
    (0, assertString_1.assertString)(str);
    let pattern;
    if (typeof patternOrString === 'string') {
        pattern = new RegExp(patternOrString, modifiers);
    }
    else {
        pattern = patternOrString;
    }
    return pattern.test(str);
}
exports.matches = matches;
